import {
  getHaversineDistance,
  SEARCH_DISTANCE_IN_KM
} from './getHaversineDistance'
import {
  ReferenceLocation,
  NearbyCityWithDistance
} from '@/types/models/Location.model'

import { LocationAllowList } from '../types/models/Location.model'
const MINIMUM_CENTER_COUNT = 3
export const findNearestLocations = ({
  referenceLocation,
  locationsData,
  isUSLocation
}: {
  referenceLocation: ReferenceLocation
  locationsData: LocationAllowList
  isUSLocation: boolean
}): NearbyCityWithDistance[] | [] => {
  if (!locationsData) {
    return []
  }

  const nearestLocations: NearbyCityWithDistance[] = []
  const locations = isUSLocation
    ? locationsData?.filter(
        (location) => location.center_count > MINIMUM_CENTER_COUNT
      )
    : locationsData
  for (const location of locations) {
    const distance = getHaversineDistance(
      referenceLocation.lat,
      referenceLocation.lng,
      location.lat,
      location.lng
    )

    if (distance < SEARCH_DISTANCE_IN_KM && distance > 0) {
      const locationWithDistance = {
        ...location,
        distance
      }
      nearestLocations.push(locationWithDistance)
    }
  }
  return nearestLocations.sort(
    (l1: NearbyCityWithDistance, l2: NearbyCityWithDistance) =>
      l1.distance - l2.distance
  )
}
